// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  /* General Styles */

.root{
  margin-top: 100px;
  padding-left: 20px;
  padding-right: 20px;
}
.container {
    margin: 20px auto;
    font-family: Arial, sans-serif;
    max-width: 1200px;
  }
  
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .progress-container {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .progress-bar {
    width: 70%;
    height: 15px;
    background-color: #007bff;
    border-radius: 5px;
  }
  
  .badge-status {
    display: inline-block;
    padding: 5px 10px;
    font-size: 14px;
    border-radius: 12px;
  }
  
  .table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .table th,
  .table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }
  
  .table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .table-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .table-title {
    text-align: center;
    margin-bottom: 20px;
    font-size: 24px;
    color: #333;
  }
  
  .search-input {
    width: 40%;
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
  }
  
  .styled-table {
    width: 100%;
    border-collapse: collapse;
    background-color: white;
  }
  
  .styled-table th,
  .styled-table td {
    padding: 6px 10px !important;
  }
  
  .styled-table th {
    background-color: #f3f4f6;
    color: #333;
  }
  
  .clickable-row {
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .clickable-row:hover {
    background-color: #f1f1f1;
  }
  
  .expanded-content {
    padding: 10px;
    background-color: #e9e9e9;
    border-radius: 4px;
  }
  
  .pagination-controls {
    text-align: center;
  }
  
  .pagination-controls button {
    padding: 8px 12px;
    margin: 0 5px;
    border: none; 
    background-color: #ff6f61;
    color: white;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .pagination-controls button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  .pagination-controls span {
    font-size: 16px;
    margin-left: 10px;
  }
  
  .status-badge {
    padding: 5px 10px;
    border-radius: 12px;
    color: white;
    font-weight: bold;
    font-size: 12px;
  }
  
  .status-badge-active {
    background-color: #57eb7a;
  }
  
  .status-badge-inactive {
    background-color: #ef4455;
  }
  
  .status-badge-pending {
    background-color: #eec240;
    color: black;
  }
  
  .action-button {
    padding: 3px 4px;
    margin-right: 5px;
    border: none;
    background-color: transparent;
    color: rgb(236, 134, 26);
    border: 1px solid rgb(236, 134, 26);
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }
  .action-button-without-border2,
  
  .action-button-without-border{
    padding: 2px 3px;
    margin-right: 5px;
   
    background-color: transparent;
    color: #53b5e3;
  
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    border: none !important;
    outline: none !important;
    background: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .action-button-without-border2:hover {
    background-color: rgba(31, 124, 80, 0.12);
    color: #1f7c50;
  
  }

  .action-button-without-border:hover {
    background-color: rgba(31, 124, 80, 0.12);
    color: #1f7c50;
  }
  
  .action-button:hover {
    background-color: rgba(31, 124, 80, 0.15);
    color: #1f7c50;
  }
  
  .expand-icon {
    cursor: pointer;
    text-align: center;
  }

  .badge-status {
    display: inline-block;
    padding: 5px 10px;
    font-size: 14px;
    border-radius: 12px;
  }
  .styled-tableStatus {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    background-color: white;
  }
  
  .styled-tableStatus th,
  .styled-tableStatus td {
    padding: 12px;
   
    border-bottom: 1px solid #ddd;
  }
  
  .styled-tableStatus th {
    background-color: #f2f2f2;
    cursor: pointer;
  }
  
  .styled-tableStatus th.sortable-header:hover {
    background-color: #eaeef2;
  }

  .create-button{
    background-color: #ff6f61;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 5px 20px;
    font-size: 16px;
    cursor: pointer;
    height: 35px;
  }

  .create-button:hover {
    background-color: #e17b22;
    color: white;
  }


 

`, "",{"version":3,"sources":["webpack://./src/pages/compliance/complianceStatus/compliance_status.css"],"names":[],"mappings":";EACE,mBAAmB;;AAErB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,wBAAwB;IACxB,mCAAmC;IACnC,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;EACA;;;IAGE,gBAAgB;IAChB,iBAAiB;;IAEjB,6BAA6B;IAC7B,cAAc;;IAEd,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,yCAAyC;IACzC,cAAc;;EAEhB;;EAEA;IACE,yCAAyC;IACzC,cAAc;EAChB;;EAEA;IACE,yCAAyC;IACzC,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;;IAEE,aAAa;;IAEb,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd","sourcesContent":["\r\n  /* General Styles */\r\n\r\n.root{\r\n  margin-top: 100px;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n}\r\n.container {\r\n    margin: 20px auto;\r\n    font-family: Arial, sans-serif;\r\n    max-width: 1200px;\r\n  }\r\n  \r\n  .header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .progress-container {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .progress-bar {\r\n    width: 70%;\r\n    height: 15px;\r\n    background-color: #007bff;\r\n    border-radius: 5px;\r\n  }\r\n  \r\n  .badge-status {\r\n    display: inline-block;\r\n    padding: 5px 10px;\r\n    font-size: 14px;\r\n    border-radius: 12px;\r\n  }\r\n  \r\n  .table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n  }\r\n  \r\n  .table th,\r\n  .table td {\r\n    border: 1px solid #ddd;\r\n    padding: 8px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .table tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .table-container {\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    background-color: #f9f9f9;\r\n    border-radius: 8px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .table-title {\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n    font-size: 24px;\r\n    color: #333;\r\n  }\r\n  \r\n  .search-input {\r\n    width: 40%;\r\n    padding: 10px;\r\n    margin-bottom: 20px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .styled-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    background-color: white;\r\n  }\r\n  \r\n  .styled-table th,\r\n  .styled-table td {\r\n    padding: 6px 10px !important;\r\n  }\r\n  \r\n  .styled-table th {\r\n    background-color: #f3f4f6;\r\n    color: #333;\r\n  }\r\n  \r\n  .clickable-row {\r\n    cursor: pointer;\r\n    transition: background-color 0.3s;\r\n  }\r\n  \r\n  .clickable-row:hover {\r\n    background-color: #f1f1f1;\r\n  }\r\n  \r\n  .expanded-content {\r\n    padding: 10px;\r\n    background-color: #e9e9e9;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .pagination-controls {\r\n    text-align: center;\r\n  }\r\n  \r\n  .pagination-controls button {\r\n    padding: 8px 12px;\r\n    margin: 0 5px;\r\n    border: none; \r\n    background-color: #ff6f61;\r\n    color: white;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .pagination-controls button:disabled {\r\n    background-color: #ccc;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n  .pagination-controls span {\r\n    font-size: 16px;\r\n    margin-left: 10px;\r\n  }\r\n  \r\n  .status-badge {\r\n    padding: 5px 10px;\r\n    border-radius: 12px;\r\n    color: white;\r\n    font-weight: bold;\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .status-badge-active {\r\n    background-color: #57eb7a;\r\n  }\r\n  \r\n  .status-badge-inactive {\r\n    background-color: #ef4455;\r\n  }\r\n  \r\n  .status-badge-pending {\r\n    background-color: #eec240;\r\n    color: black;\r\n  }\r\n  \r\n  .action-button {\r\n    padding: 3px 4px;\r\n    margin-right: 5px;\r\n    border: none;\r\n    background-color: transparent;\r\n    color: rgb(236, 134, 26);\r\n    border: 1px solid rgb(236, 134, 26);\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n  }\r\n  .action-button-without-border2,\r\n  \r\n  .action-button-without-border{\r\n    padding: 2px 3px;\r\n    margin-right: 5px;\r\n   \r\n    background-color: transparent;\r\n    color: #53b5e3;\r\n  \r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    border: none !important;\r\n    outline: none !important;\r\n    background: none !important;\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n  }\r\n\r\n  .action-button-without-border2:hover {\r\n    background-color: rgba(31, 124, 80, 0.12);\r\n    color: #1f7c50;\r\n  \r\n  }\r\n\r\n  .action-button-without-border:hover {\r\n    background-color: rgba(31, 124, 80, 0.12);\r\n    color: #1f7c50;\r\n  }\r\n  \r\n  .action-button:hover {\r\n    background-color: rgba(31, 124, 80, 0.15);\r\n    color: #1f7c50;\r\n  }\r\n  \r\n  .expand-icon {\r\n    cursor: pointer;\r\n    text-align: center;\r\n  }\r\n\r\n  .badge-status {\r\n    display: inline-block;\r\n    padding: 5px 10px;\r\n    font-size: 14px;\r\n    border-radius: 12px;\r\n  }\r\n  .styled-tableStatus {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-bottom: 20px;\r\n    background-color: white;\r\n  }\r\n  \r\n  .styled-tableStatus th,\r\n  .styled-tableStatus td {\r\n    padding: 12px;\r\n   \r\n    border-bottom: 1px solid #ddd;\r\n  }\r\n  \r\n  .styled-tableStatus th {\r\n    background-color: #f2f2f2;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .styled-tableStatus th.sortable-header:hover {\r\n    background-color: #eaeef2;\r\n  }\r\n\r\n  .create-button{\r\n    background-color: #ff6f61;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    padding: 5px 20px;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    height: 35px;\r\n  }\r\n\r\n  .create-button:hover {\r\n    background-color: #e17b22;\r\n    color: white;\r\n  }\r\n\r\n\r\n \r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
